/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { Card, CardContent, Tooltip } from '@material-ui/core';
import {
  ScreenContainer, CommonPagination, CommonSearch,
} from '../../CommonComponents';
import MonitorUserTable from './MonitorUserTable';
import CommonButton from '../../CommonComponents/CommonButton';
import {
  getSuppliers, createSupplierUser, getSupplierUsers, showUserForm, importVendorUsers,
} from '../../redux/actions/suppliers';
import UserCreation from '../../CommonComponents/UserCreation'
import { exportVendorUsers, exportSuppliers } from '../../redux/actions/common';
import { userTypes } from '../../Utils/constants';
import FallbackCard from '../../CommonComponents/FallbackCard';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Monitor = ({
  getAllSuppliers,
  allSuppliers,
  createSupplier,
  getUsers,
  userForm,
  showForm,
  totalSupplierUserPages,
  exportVendors,
  importUsers,
  supplierExport,
}) => {
  const history = useHistory();
  const [supplier, setSupplier] = useState(null)

  const query = useQuery();
  const page = parseInt(query.get('page') || '1', 10);

  useEffect(() => {
    if (supplier) {
      getUsers(supplier.value, page);
    } else {
      const user = JSON.parse(localStorage.getItem('user'))
      if (user.userType === 'supplier') {
        setSupplier({ value: user.id })
        getUsers(user.id, page);
      } else {
        getAllSuppliers();
      }
    }
  }, [getUsers, page, supplier, getAllSuppliers]);

  // const fetchSuppliers = () => {
  //   getAllSuppliers();
  // }

  const createUser = (fields) => {
    createSupplier(supplier.id, fields);
  }

  const handleChange = (val) => {
    if (val) {
      const sup = allSuppliers.find((item) => item.id === val.value);
      setSupplier(sup)
      if (sup) { getUsers(sup.id, 0); }
    } else {
      setSupplier(null)
    }
  }

  const exportData = () => {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user.userType === 'supplier') exportVendors(user.depended_field)
    else { exportVendors(supplier ? supplier.value : null) }
  }

  const handleChangeFile = (files) => {
    importUsers(files[0])
    history.push('/monitors');
  }

  const user = JSON.parse(localStorage.getItem('user'))

  return (
    <ScreenContainer title="Monitors">
      {user.userType !== 'supplier'
        ? (
          <>
            <Card>
              <CardContent>
                <div className="row">
                  {/* {!allSuppliers
                    ? (
                      <div className="col-3">
                        <CommonButton
                          variant="outlined"
                          color="primary"
                          onClick={() => fetchSuppliers()}
                        >
                          Fetch Suppliers
                        </CommonButton>
                      </div>
                    )
                    : null} */}
                  {allSuppliers
                    ? (
                      <>
                        <div className="col-9">
                          <CommonSearch label="Suppliers" value={supplier} data={allSuppliers} onChange={handleChange} />
                        </div>
                        {(supplier && user && user.userType !== 'creative')
                          ? (
                            <div className="col-3 text-right">
                              <CommonButton
                                variant="outlined"
                                color="primary"
                                onClick={() => showForm(true)}
                              >
                                <b>Add User</b>
                              </CommonButton>
                            </div>
                          ) : null }
                      </>
                    )
                    : null}
                </div>
              </CardContent>
            </Card>
            <br />
          </>
        )
        : null}
      {(user && (user.userType === userTypes.manager || user.userType === userTypes.admin))
        ? (
          <>
            <div className="row">
              <div className="col-8">
                <CommonButton
                  onClick={() => supplierExport()}
                  basic="true"
                  color="primary"
                >
                  <b>Export Suppliers</b>
                </CommonButton>
                <input
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style={{ display: 'none' }}
                  id="import-sites"
                  onChange={(e) => handleChangeFile(e.target.files)}
                  type="file"
                />
                <Tooltip disableFocusListener title="Please make sure you have already created monitor before mapping." placement="right" arrow>
                  <label htmlFor="import-sites">
                    <CommonButton
                      variant="raised"
                      component="span"
                    >
                      <b className="text-primary">Import Monitors</b>
                    </CommonButton>
                  </label>
                </Tooltip>
              </div>
              <div className="col-4 text-right">
                <CommonButton
                  onClick={() => exportData()}
                  color="primary"
                >
                  <b>Export Users</b>
                </CommonButton>
              </div>
            </div>
          </>
        ) : null}
      {supplier
        ? <MonitorUserTable />
        : <FallbackCard text="No data found" /> }
      {supplier && totalSupplierUserPages > 1 ? (
        <CommonPagination
          baseUrl="monitors"
          totalPages={totalSupplierUserPages}
        />
      ) : null}
      {(userForm && supplier)
        ? (
          <UserCreation
            userType="monitor"
            setModal={showForm}
            createUser={createUser}
            title={`Supplier :- ${supplier.supplierName}`}
          />
        )
        : null}
    </ScreenContainer>
  );
}

const mapState = (state) => ({
  allSuppliers: state.suppliers.allSuppliers,
  userForm: state.suppliers.showUserForm,
  totalSupplierUserPages: state.suppliers.totalSupplierUserPages,
});

const mapActions = {
  getAllSuppliers: getSuppliers,
  createSupplier: createSupplierUser,
  getUsers: getSupplierUsers,
  showForm: showUserForm,
  exportVendors: exportVendorUsers,
  importUsers: importVendorUsers,
  supplierExport: exportSuppliers,
};

export default connect(mapState, mapActions)(Monitor);
